module.exports = __webpack_public_path__ + "static/media/3-4-Tezky-kriz-nesl.26e3ae08.jpg";